;(function () {
  if (!customElements.get('planted-store-locator')) {
    const MAX_SEARCH_RESULTS = 50
    const boundingBoxes = {
      CH: [6.02, 45.78, 10.44, 47.83],
      DE: [5.99, 47.3, 15.02, 54.98],
      AT: [9.48, 46.43, 16.98, 49.04],
      FR: [-5.0, 42.5, 9.56, 51.15],
      IT: [6.75, 36.62, 18.48, 47.12],
      GB: [-7.57, 49.96, 1.68, 58.64]
    }

    let openMarker = undefined
    const toggleHighlight = function (marker, forceOpen) {
      const contentEl = marker.content
      const isOpen = contentEl.classList.contains('is-open')

      if (isOpen && !forceOpen) {
        marker.zIndex = 0
        contentEl.classList.remove('is-open')
      } else {
        marker.zIndex = 99999999
        contentEl.classList.add('is-open')

        if (openMarker && openMarker !== marker) {
          openMarker.zIndex = 0
          openMarker.content.classList.remove('is-open')
        }
        openMarker = marker
      }
    }.bind(this)

    const contentHtmlTemplate = document.createElement('div')
    contentHtmlTemplate.classList.add('group')
    const afterClassesOpen =
      "after:border-l-[9px] after:border-l-transparent after:border-r-[9px] after:border-r-transparent after:border-t-[9px] after:border-t-purple after:content-[' '] after:h-0 after:left-1/2 after:absolute after:top-[100%] after:-translate-x-1/2 after:w-0"

    contentHtmlTemplate.innerHTML = `
      <div class="icon group-[.is-open]:hidden">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 40 50" fill="none">
          <path d="M40 20C40 36 20 50 20 50C20 50 0 36 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z" fill="#61269E" stroke="white" />
        </svg>
      </div>
  
      <div class="-translate-y-1.5 items-start hidden group-[.is-open]:!flex max-w-[258px] z-40 p-3 pr-10 bg-white border-2 border-purple shadow-xl rounded-xl ${afterClassesOpen}">
      <div class="ds-caption" data-info></div>
      
      <div data-close class="absolute top-4 right-4 w-8 h-8 translate-x-4 -translate-y-4 flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.550476 0.550476C0.867777 0.233175 1.38222 0.233175 1.69952 0.550476L6 4.85095L10.3005 0.550476C10.6178 0.233175 11.1322 0.233175 11.4495 0.550476C11.7668 0.867777 11.7668 1.38222 11.4495 1.69952L7.14905 6L11.4495 10.3005C11.7668 10.6178 11.7668 11.1322 11.4495 11.4495C11.1322 11.7668 10.6178 11.7668 10.3005 11.4495L6 7.14905L1.69952 11.4495C1.38222 11.7668 0.867777 11.7668 0.550476 11.4495C0.233175 11.1322 0.233175 10.6178 0.550476 10.3005L4.85095 6L0.550476 1.69952C0.233175 1.38222 0.233175 0.867777 0.550476 0.550476Z" fill="#61269E"/>
          </svg>
      </div>
      
  </div>
      `

    function isTrueColumn(col) {
      return col === 1 || col === '1' || col === 'true'
    }

    function buildContent(info, templateEl) {
      const content = contentHtmlTemplate.cloneNode(true)
      const el = templateEl.firstElementChild.cloneNode(true)
      const imageEl = el.querySelector('[data-image]')
      if (info.image) {
        imageEl.src = info.image
      } else {
        imageEl.remove()
      }
      el.querySelector('[data-name]').textContent = info.name
      const address = `${info.street}, ${info.postcode} ${
        info.city || info.country
      }`
      el.querySelector('[data-address]').textContent = address
      const to = encodeURIComponent(address)

      const directionEl = el.querySelector('[data-directions]')

      directionEl.href = `https://maps.google.com/?daddr=${to}&saddr=`
      directionEl.addEventListener('touchend', (event) => {
        event.preventDefault()
        window.open(directionEl.href, '_blank')
        return false
      })

      content.querySelector('[data-info]').appendChild(el)

      return content
    }

    function getBoundsForShopDomain(shopDomain, boundingBoxes) {
      if (shopDomain === 'plantedfoods.myshopify.com') {
        const box = boundingBoxes.CH
        return new google.maps.LatLngBounds(
          new google.maps.LatLng(box[1], box[0]),
          new google.maps.LatLng(box[3], box[2])
        )
      } else if (shopDomain === 'planted-foods-de.myshopify.com') {
        const box = boundingBoxes.DE
        const bounds = new google.maps.LatLngBounds(
          new google.maps.LatLng(box[1], box[0]),
          new google.maps.LatLng(box[3], box[2])
        )

        const boxAT = boundingBoxes.AT
        bounds.extend(new google.maps.LatLng(boxAT[1], boxAT[0]))
        bounds.extend(new google.maps.LatLng(boxAT[3], boxAT[2]))
        return bounds
      } else if (shopDomain === 'planted-foods-uk.myshopify.com') {
        const box = boundingBoxes.GB
        return new google.maps.LatLngBounds(
          new google.maps.LatLng(box[1], box[0]),
          new google.maps.LatLng(box[3], box[2])
        )
      } else if (shopDomain === 'planted-foods-eu.myshopify.com') {
        const box = boundingBoxes.GB
        const bounds = new google.maps.LatLngBounds(
          new google.maps.LatLng(box[1], box[0]),
          new google.maps.LatLng(box[3], box[2])
        )

        const boxIT = boundingBoxes.IT
        bounds.extend(new google.maps.LatLng(boxIT[1], boxIT[0]))
        bounds.extend(new google.maps.LatLng(boxIT[3], boxIT[2]))
        return bounds
      } else if (shopDomain === 'plantedfoods-fr.myshopify.com') {
        const box = boundingBoxes.FR
        return new google.maps.LatLngBounds(
          new google.maps.LatLng(box[1], box[0]),
          new google.maps.LatLng(box[3], box[2])
        )
      } else if (shopDomain === 'planted-foods-it.myshopify.com') {
        const box = boundingBoxes.IT
        return new google.maps.LatLngBounds(
          new google.maps.LatLng(box[1], box[0]),
          new google.maps.LatLng(box[3], box[2])
        )
      }
    }

    function hav(x) {
      const s = Math.sin(x / 2)
      return s * s
    }

    function relativeHaversineDistance(lat1, lon1, lat2, lon2) {
      const PI_180 = Math.PI / 180

      const aLatRad = lat1 * PI_180
      const bLatRad = lat2 * PI_180
      const aLngRad = lon1 * PI_180
      const bLngRad = lon2 * PI_180

      const ht =
        hav(bLatRad - aLatRad) +
        Math.cos(aLatRad) * Math.cos(bLatRad) * hav(bLngRad - aLngRad)
      // since we're only interested in relative differences,
      // there is no need to multiply by earth radius or to sqrt the squared differences
      return Math.asin(ht)
    }

    class PlantedStoreLocator extends HTMLElement {
      connectedCallback() {
        this.filterByType = 'all'
        this.filterUnrealSteak = false
        this.stores = []
        this.map = undefined
        this.markerClusterer = undefined
        // list of markers that should not be clustered because
        // are part of the search results (hence they should all be visible)
        this.notClusteredMarkers = []
        this.init()
      }

      async loadMapScripts() {
        const scripts = [
          'https://maps.googleapis.com/maps/api/js?key=AIzaSyAtiplUfnDdSqWG9p8fyWAV3DymL82c44c&v=weekly&libraries=places',
          'https://unpkg.com/@googlemaps/markerclusterer@2.5.2/dist/index.min.js'
        ]

        await Promise.all(
          scripts.map((url) => {
            return new Promise((resolve, reject) => {
              const scriptEl = document.createElement('script')
              scriptEl.src = url
              scriptEl.onabort = reject
              scriptEl.onload = resolve
              document.body.appendChild(scriptEl)
            })
          })
        )
      }

      getMarkerForStore(store) {
        const info = {
          type: store.tags.trim().toLocaleLowerCase(),
          name: store.name,
          city: store.city,
          street: store.street,
          postcode: store.postcode,
          country: store.country,
          image: store.thumbnail,
          promoted: store.promoted
        }
        const templateEl = this.querySelector('[data-list-item-template]')

        const { lat, lng } = store
        const marker = new this.AdvancedMarkerElement({
          position: { lat, lng },
          content: buildContent(info, templateEl)
        })
        marker.plantedData = info
        marker.addListener('click', () => {
          toggleHighlight(marker)
          this.map.panTo(marker.position)
        })
        return marker
      }

      sortAndDisplayMarkers(map, stores, listEl, fromAddress) {
        this.reclusterMarkers()

        listEl.scrollTop = 0
        const center = map.getCenter()
        const lat = center.lat()
        const lng = center.lng()
        stores.map((a) => delete a.relativeDistance)

        stores.sort((a, b) => {
          if (isTrueColumn(a.promoted)) {
            return -1
          }
          if (isTrueColumn(b.promoted)) {
            return 1
          }

          if (!a.relativeDistance) {
            a.relativeDistance = relativeHaversineDistance(
              a.lat,
              a.lng,
              lat,
              lng
            )
          }

          if (!b.relativeDistance) {
            b.relativeDistance = relativeHaversineDistance(
              a.lat,
              a.lng,
              lat,
              lng
            )
          }
          return a.relativeDistance - b.relativeDistance
        })

        listEl.innerHTML = ''
        let count = 0
        const templateEl = this.querySelector('[data-list-item-template]')
        for (let index = 0; index < stores.length; index++) {
          const store = stores[index]

          if (!this.isStoreVisible(store)) {
            continue
          }

          if (count >= MAX_SEARCH_RESULTS) {
            break
          }

          count++
          let marker = store.marker
          if (!marker) {
            store.marker = this.getMarkerForStore(store)
            marker = store.marker
          }
          this.notClusteredMarkers.push(marker)

          const el = templateEl.firstElementChild.cloneNode(true)
          el.setAttribute('data-tags', store.tags)
          el.setAttribute('data-steak', store.steak)
          el.className = 'block px-8 py-4'
          el.addEventListener('click', (event) => {
            map.panTo(marker.position)
            toggleHighlight(marker, true)
          })
          const imageEl = el.querySelector('[data-image]')
          if (marker.plantedData.image) {
            imageEl.src = marker.plantedData.image
          } else {
            imageEl.remove()
          }
          if (isTrueColumn(marker.plantedData.promoted)) {
            el.querySelector('[data-promoted]').style.display = ''
          }
          el.querySelector('[data-name]').textContent = marker.plantedData.name
          const address = `${marker.plantedData.street}, ${
            marker.plantedData.postcode
          } ${marker.plantedData.city || marker.plantedData.country}`
          el.querySelector('[data-address]').textContent = address
          const to = encodeURIComponent(address)
          el.querySelector(
            '[data-directions]'
          ).href = `https://maps.google.com/?daddr=${to}&saddr=${fromAddress}`
          listEl.appendChild(el)
        }

        this.unclusterMarkers(this.notClusteredMarkers)
      }

      reclusterMarkers() {
        this.markerClusterer.addMarkers(this.notClusteredMarkers)
        this.notClusteredMarkers = []
      }

      unclusterMarkers(markers) {
        this.markerClusterer.removeMarkers(markers)
        for (var i = 0; i < markers.length; i++) {
          markers[i].setMap(this.map)
        }
      }

      initForm(map, AdvancedMarkerElement) {
        const formEl = window.innerWidth <= 768 ? this.querySelectorAll('form')[0] : this.querySelectorAll('form')[1]
        const filterEl = window.innerWidth <= 768 ? formEl : this.querySelectorAll('form')[2]
        if(window.innerWidth >= 768) this.querySelector('#filterDeleteOnLargeScreen').remove()

        const storeTypeEls = filterEl.querySelectorAll(
          'input[name=store_type]'
        )
        storeTypeEls.forEach((storeTypeEl) => {
          console.log(storeTypeEl)
          storeTypeEl.addEventListener('change', () => {
            storeTypeEls.forEach((el) => {
              el.checked = el.value === storeTypeEl.value
            })
            this.filterByType = storeTypeEl.value

            this.updateMarkersVisibility(this.stores)
          })
        })

        const showUnrealSteakEls = filterEl.querySelectorAll(
          'input[name=unreal_steak]'
        )
        showUnrealSteakEls.forEach((showUnrealSteakEl) => {
          showUnrealSteakEl.addEventListener('change', () => {
            showUnrealSteakEls.forEach((el) => {
              el.checked = showUnrealSteakEl.checked
            })
            if (showUnrealSteakEl.checked) {
              this.filterUnrealSteak = true
            } else {
              this.filterUnrealSteak = false
            }
            this.updateMarkersVisibility(this.stores)
          })
        })

        const locationInputEl = formEl.querySelector('input[name=location]')
        const locateEl = formEl.querySelector('[data-locate]')
        let locationWatcherId, userPositionMarker

        function clearGeolocationWatcher() {
          if (locationWatcherId) {
            navigator.geolocation.clearWatch(locationWatcherId)
            locationWatcherId = undefined
            locateEl.classList.remove('animate-pulse')
          }
        }

        locateEl.addEventListener(
          'click',
          function (event) {
            event.preventDefault()
            if (!locationWatcherId) {
              locateEl.classList.add('animate-pulse')
              locationInputEl.value = ''
              locationWatcherId = navigator.geolocation.watchPosition(
                (position) => {
                  const latLng = new google.maps.LatLng(
                    position.coords.latitude,
                    position.coords.longitude
                  )
                  map?.panTo(latLng)
                  map.setZoom(14)
                  const listEl = this.querySelector('[data-list]')
                  this.sortAndDisplayMarkers(map, this.stores, listEl, '')

                  if (!userPositionMarker) {
                    map.setCenter(latLng)
                    const content = document.createElement('div')
                    content.innerHTML = `
                      <span class="relative flex h-4 w-4">
                      <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#0ea5e9] opacity-75"></span>
                      <span class="relative inline-flex rounded-full shadow h-4 w-4 bg-[#0ea5e9] border-2 border-white"></span>
                    </span>
                  </div>
                  `

                    userPositionMarker = new AdvancedMarkerElement({
                      map: map,
                      position: latLng,
                      content
                    })
                  } else {
                    userPositionMarker.position = latLng
                  }
                }
              )
            } else {
              clearGeolocationWatcher()
            }
          }.bind(this)
        )

        const service = new google.maps.places.PlacesService(map)
        formEl.addEventListener('submit', (event) => {
          event.preventDefault()
          const request = {
            query: formEl.querySelector('input[name=location]').value || '',
            fields: ['place_id', 'geometry', 'formatted_address']
          }
          service.findPlaceFromQuery(request, (results, status) => {
            if (
              status === google.maps.places.PlacesServiceStatus.OK &&
              results
            ) {
              const { location, viewport } = results[0].geometry
              map.setCenter(location)
              map.fitBounds(viewport)
              clearGeolocationWatcher()
              const listEl = this.querySelector('[data-list]')
              this.sortAndDisplayMarkers(
                map,
                this.stores,
                listEl,
                results[0].formatted_address
              )
            }
          })
        })

        const autocomplete = new google.maps.places.Autocomplete(
          locationInputEl,
          {
            types: ['geocode'],
            fields: ['place_id', 'geometry', 'formatted_address']
          }
        )

        let originLocation = map.getCenter()
        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace()
          originLocation = map.getCenter()

          if (!place.geometry) {
            // User entered the name of a Place that was not suggested and
            // pressed the Enter key, or the Place Details request failed.
            return
          }

          clearGeolocationWatcher()
          // Recenter the map to the selected address
          originLocation = place.geometry.location
          map.setCenter(originLocation)
          map.setZoom(15)

          const listEl = this.querySelector('[data-list]')
          this.sortAndDisplayMarkers(
            map,
            this.stores,
            listEl,
            place.formatted_address
          )
        })
      }

      isStoreVisible(store) {
        if (
          (this.filterByType === 'all' ||
            this.filterByType === store.tags.trim().toLocaleLowerCase()) &&
          (!this.filterUnrealSteak || isTrueColumn(store.steak))
        ) {
          return true
        }
        return false
      }

      isStoreInBounds(store) {
        const bounds = this.map.getBounds()
        return bounds.contains(store.latLng)
      }

      updateMarkersVisibility(stores) {
        this.markerClusterer.clearMarkers(true)
        let count = 0
        stores.map((store) => {
          if (this.isStoreVisible(store) && this.isStoreInBounds(store)) {
            count++
            let marker = store.marker
            if (!marker) {
              store.marker = this.getMarkerForStore(store)
              marker = store.marker
            }
            this.markerClusterer.addMarker(marker, true)
          }
        })
        this.markerClusterer.render()
        this.updateMarkerList()
      }

      updateMarkerList() {
        const listEl = this.querySelector('[data-list]')
        for (const el of listEl.children) {
          const tags = el.getAttribute('data-tags')
          const steak = el.getAttribute('data-steak')
          if (!tags || !steak) {
            continue
          }
          if (
            (this.filterByType === 'all' ||
              this.filterByType === tags.trim().toLocaleLowerCase()) &&
            (!this.filterUnrealSteak || isTrueColumn(steak))
          ) {
            el.style.display = ''
          } else {
            el.style.display = 'none'
          }
        }
      }

      async loadStores() {
        const sourceUrl = this.getAttribute('data-source-url')
        return fetch(sourceUrl).then((res) => res.json())
      }

      async init() {
        this.updateMarkersVisibility.bind(this)
        const [stores] = await Promise.all([
          this.loadStores(),
          this.loadMapScripts()
        ])

        const [{ Map }, { AdvancedMarkerElement }] = await Promise.all([
          google.maps.importLibrary('maps'),
          google.maps.importLibrary('marker')
        ])
        this.AdvancedMarkerElement = AdvancedMarkerElement

        const map = new Map(document.getElementById('map'), {
          center: { lat: 47.44982221297666, lng: 8.703986158735445 },
          zoom: 5,
          mapId: 'bdfb866f9e11bc6b',
          disableDefaultUI: true
        })

        google.maps.event.addListener(map, 'bounds_changed', () => {
          this.updateMarkersVisibility(this.stores)
        })

        const shopDomain = this.getAttribute('data-shopify-shop')
        const bounds = getBoundsForShopDomain(shopDomain, boundingBoxes)
        if (bounds) {
          map.fitBounds(bounds)
        }

        this.initForm(map, AdvancedMarkerElement)

        this.querySelector('[data-zoom-in]')?.addEventListener('click', () => {
          const zoom = map.getZoom()
          if (zoom !== undefined) {
            map.setZoom(zoom + 1)
          }
        })

        this.querySelector('[data-zoom-out]')?.addEventListener('click', () => {
          const zoom = map.getZoom()
          if (zoom !== undefined) {
            map.setZoom(zoom - 1)
          }
        })

        const listEl = this.querySelector('[data-list]')
        const emptyMessage = listEl.getAttribute('data-empty')
        listEl.innerHTML = `<div class="ds-body p-6">${emptyMessage}</div>`

        const markersToDisplay = []
        let count = 0
        this.stores = stores
        for (let index = 0; index < stores.length; index++) {
          const store = stores[index]

          const lat = parseFloat(store.lat)
          const lng = parseFloat(store.lng)
          store.latLng = new google.maps.LatLng(lat, lng)
          store.lat = lat
          store.lng = lng

          if (!bounds.contains(store.latLng)) {
            continue
          }

          if (!isNaN(lat) && !isNaN(lng)) {
            store.marker = this.getMarkerForStore(store)

            count++
            markersToDisplay.push(store.marker)
          }
        }

        this.map = map
        this.markerClusterer = new markerClusterer.MarkerClusterer({
          markers: markersToDisplay,
          map,
          renderer: {
            render: ({ count, position }) => {
              const title = `Cluster of ${count} markers`
              const zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count
              const div = document.createElement('div')
              div.className =
                'bg-purple shadow-cluster-pin text-white rounded-full text-xs font-sans drop-shadow px-2 py-1'
              div.textContent = count
              const clusterOptions = {
                map,
                position,
                zIndex,
                title,
                content: div
              }
              return new google.maps.marker.AdvancedMarkerElement(
                clusterOptions
              )
            }
          }
        })

        google.maps.event.addListenerOnce(map, 'idle', () => {
          const params = new URLSearchParams(location.search)

          if (params.get('unrealsteak')) {
            this.filterUnrealSteak = true
            this.querySelector('form')
              .querySelectorAll('input[name=unreal_steak]')
              .forEach((el) => (el.checked = true))
            this.updateMarkersVisibility(this.stores)
          }

          const address = params.get('address')
          if (address) {
            this.querySelector('form').querySelector(
              'input[name=location]'
            ).value = address
            const request = {
              query: address,
              fields: ['place_id', 'geometry', 'formatted_address']
            }
            const service = new google.maps.places.PlacesService(map)
            service.findPlaceFromQuery(request, (results, status) => {
              if (
                status === google.maps.places.PlacesServiceStatus.OK &&
                results
              ) {
                const { location, viewport } = results[0].geometry
                map.setCenter(location)
                map.fitBounds(viewport)
                const listEl = this.querySelector('[data-list]')
                this.sortAndDisplayMarkers(
                  map,
                  this.stores,
                  listEl,
                  results[0].formatted_address
                )
              }
            })
          }
        })
      }
    }
    customElements.define('planted-store-locator', PlantedStoreLocator)
  }
})()
